module.exports = __webpack_public_path__ + "static/media/dispensary-delivery.a7096a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/dispensary-delivery.svg
// module id = 1953
// module chunks = 0